import { useTranslation } from 'libs/i18n';
import { Button, Typography, Stack, ListTypography } from 'libs/ui';

import { BodyStyled, FormContentStyled } from './OnboardingInfoView.styles';

interface Props {
  texts: string[];
  onOnboarding?: () => void;
}

export const OnboardingInfoView = ({ texts, onOnboarding }: Props) => {
  const { t } = useTranslation();

  return (
    <FormContentStyled>
      <BodyStyled className="registration-onboarding">
        <Stack className="registration-onboarding-content" spacing={24}>
          <Typography as="h1" variant="title" variantMobile="subtitle">
            {t('onboarding-info.title')}
          </Typography>

          <Typography
            variant="bodyBold"
            variantMobile="captionBold"
            whiteSpace="pre-wrap"
          >
            {t('onboarding-info.subtitle')}
          </Typography>

          <Stack spacing={24} spacingMobile={32}>
            <ListTypography
              listType="ul"
              spacing={16}
              texts={texts}
              variantMobile="caption"
              />
            <Stack className="registration-onboarding-button">
              <Button
                label={t('onboarding-info.button')}
                onClick={onOnboarding}
                />
            </Stack>
          </Stack>
        </Stack>
      </BodyStyled>
    </FormContentStyled>
  );
};
